<!--
	@name app-firm-dialog-add-edit-panel
	@description Select panel to associate with trading style
	@date 2020/08/26
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<common-dialog ref="dialog" :component="$options.name" :max-width="500">
		<template #header>
			Add/Edit Panel
		</template>

		<template #body>
			<v-skeleton-loader v-if="!panelList" type="heading" />
			<dynamic-form v-else ref="dynamicForm" :form-schema="formSchema" :form-data="formData" :submit-button-loading="loading" @dynamic-form-submit="submit" />
		</template>
	</common-dialog>
</template>

<script>
	import { mapActions, mapState } from 'vuex';
	import CommonDialog from '@/component/common/dialog';
	import DynamicForm from '@/component/common/base/dynamic-form';
	import { ElementTools } from '@/utils';

	export default {
		name: 'app-firm-dialog-add-edit-panel',

		components: { CommonDialog, DynamicForm },

		data() {
			return {
				loading: false,
				formData: {},
				tradingStyle: {},
				panelList: []
			};
		},

		computed: {
			...mapState('Account', ['user']),

			panelOptions() {
				let panelOptions = this.panelList.map((panel) => ({ value: { id: panel.id, name: panel.name }, text: panel.name }));
				panelOptions.unshift({ id: null, name: "None", text: "None" });
				return panelOptions;
			},

			formSchema() {
				return [
					{
						type: 'select',
						multiple: false,
						name: 'selected_panel',
						display: 'Select a panel to associate with this trading style',
						rules: 'required',
						options: this.panelOptions,
						sm: 12
					}
				];
			}
		},

		methods: {
			...mapActions('AccountOrganisationTradingStyle', ['updatePanel']),
			...mapActions('AccountPanel', ['loadPanelList']),

			/**
			 * @name open
			 * @description Open dialog and set properties
			 */
			async open(tradingStyle) {
				this.tradingStyle = tradingStyle;
				this.formData = {};

				this.loadPanelList().then((data) => {
					this.panelList = data.data;
					const selectedPanel = this.panelList.find((panel) => panel.id == tradingStyle.panelId);

					if(selectedPanel) {
						this.formData = { selected_panel: { id: selectedPanel.id, name: selectedPanel.name } };
					} else {
						this.formData = { selected_panel: { id: null, name: null } };
					}
				});


				if (this.$refs.dynamicForm) this.$refs.dynamicForm.$refs.observer.reset();
				this.$refs.dialog.open();
			},

			/**
			 * @name submit
			 * @description submit new client details
			 */
			async submit(data) {
				this.updatePanel({
					id: this.tradingStyle.id,
					payload: {
						panelId: data.selected_panel.id
					}
				})
					.then(() => {
						ElementTools.fireNotification(this.$el, 'success', 'Trading style panel has been updated successfully');
						this.$refs.dialog.close();
					})
					.catch((e) => {
						console.log(e);
						let message = 'Failed to edit trading style panel';
						ElementTools.fireNotification(this.$el, 'error', message);
					})
					.finally(() => {
						this.submitting = false;
						this.$refs.dialog.close();
					});
			}
		}
	};
</script>
